import ReviewerShell from '@/components/reviewer/ReviewerShell';

const WAVES = [
  ['W1', 'scene_event_segmenter.v1', 'Every on-screen event, dramatic scene, and value-change cause. Prefer start_char/end_char on events.'],
  ['W2', 'character_inventory.v1', 'Complete character list (on-screen or mentioned), not principals only. Role/object nouns stay exact-match. For a first name (Jack), merge surname variants (Jack Goodwin) into one character and a combined occurrence count.'],
  ['W3', 'protagonist_beat_tagger.v1', 'Name the protagonist, then every protagonist-centred beat. Lock W3 before W4–W8.'],
  ['W4', 'dramatic_problem_lister.v1', 'Every dramatic problem in those beats.'],
  ['W5', 'beat_cdp_yes_no.v1', 'Central dramatic problem, then YES/NO per beat.'],
  ['W6', 'structural_beat_detector.v1', 'Present stages of the ten-stage sequence.'],
  ['W7', 'dialogue_span_extractor.v1', 'Causal dialogue exchange for dialogue-driven beats.'],
  ['W8', 'dominant_emotion_tagger.v1', 'One emotion per beat, then exactly three story emotions by frequency.'],
];

export default function ReviewerGuide() {
  return (
    <ReviewerShell subtitle="Labeling rules">
      <div className="mx-auto max-w-3xl space-y-6">
        <h1 className="text-2xl font-sans font-bold">How to review</h1>
        <p className="text-sm text-white/60 font-sans leading-relaxed">
          Accept keeps the proposed label. Edit when the current item is wrong. If the model missed
          a label (for example a character named before the highlighted one), use Add label, select
          the span in the screenplay, and save. Do not gold W4–W8 until W3 is locked for that
          script. Accepted labels are highlighted in grey everywhere they appear. Current / next
          spans use amber and blue.
        </p>
        <ul className="space-y-3">
          {WAVES.map(([wave, slug, blurb]) => (
            <li key={slug} className="ni-panel p-4">
              <p className="font-mono text-xs text-white/45">
                {wave} · {slug}
              </p>
              <p className="mt-1 text-sm font-sans text-white/80">{blurb}</p>
            </li>
          ))}
        </ul>
        <p className="text-xs text-white/40 font-mono">
          Keys: A accept · U undo · R edit · N add label · Q back to panel. Gold writes _qa.mode=human for
          merge.
        </p>
      </div>
    </ReviewerShell>
  );
}
